const baseStyle = ({}: Record<string, any>) => ({
  _container: {
    padding: 4,
    justifyContent: 'center',
  },
  _bodyContainer: {
    alignItems: 'center',
    width: '100%',
  },
  _descriptionContainer: {
    flex: 3,
  },
  _title: {
    size: 'heading-6',
    marginBottom: 2,
  },
  _body: {
    lineHeight: 24,
    fontSize: 16,
  },
  _footer: {
    marginTop: 8,
  },
  _verticalImage: {
    width: '100%',
    height: '100%',
  },
  _horizontalImage: {
    flex: 1,
    mr: 4,
    height: '100%',
    overflow: 'hidden',
    justifyContent: 'center',
  },
  _horizontalSVGContainer: {
    flex: 1,
    mr: 4,
    ratio: 0.85,
    overflow: 'hidden',
    justifyContent: 'center',
  },
  _verticalImageContainer: {
    width: '100%',
    ratio: 16 / 9,
    marginBottom: 8,
    alignItems: 'center',
  },
});

export default {
  baseStyle,
};
